import React from "react";
import { Link } from "react-router-dom";

const PropertyCard = ({ item }) => { 
  const imageUrl = item.ImagePath;
  return (
    <div className="col-xl-4 col-lg-6 col-md-6">
      <div className="homelengo-box">
        <div className="archive-top">
          <Link className="images-group" to={`/property/${item.url}/${item.id}`}>
            <div className="images-style">
              <img src={imageUrl+'/w=421,sharpen=1'} alt={item.title}  className=" ls-is-cached lazyloaded" />
            </div>

            <div className="top">
              <ul className="d-flex gap-6">
                <li className="flag-tag primary">Featured</li>
                <li className="flag-tag style-1">{item.offering_type}</li>
              </ul>
            </div>
          </Link>
        </div>

        <div className="archive-bottom">
          <div className="content-top">
           
            <h6 className="text-capitalize"><Link className="link"  to={`/property/${item.url}/${item.id}`}>
            {item.title}</Link></h6>
           <p>
                          <svg
                            width={16}
                            height={16}
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 7C10 7.53043 9.78929 8.03914 9.41421 8.41421C9.03914 8.78929 8.53043 9 8 9C7.46957 9 6.96086 8.78929 6.58579 8.41421C6.21071 8.03914 6 7.53043 6 7C6 6.46957 6.21071 5.96086 6.58579 5.58579C6.96086 5.21071 7.46957 5 8 5C8.53043 5 9.03914 5.21071 9.41421 5.58579C9.78929 5.96086 10 6.46957 10 7Z"
                              stroke="#000"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M13 7C13 11.7613 8 14.5 8 14.5C8 14.5 3 11.7613 3 7C3 5.67392 3.52678 4.40215 4.46447 3.46447C5.40215 2.52678 6.67392 2 8 2C9.32608 2 10.5979 2.52678 11.5355 3.46447C12.4732 4.40215 13 5.67392 13 7Z"
                              stroke="#000"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <span className="propertycardspan">{item.community}, {item.city}</span>
                        </p>

            <ul className="meta-list">
              <li>Beds: <strong>{item.bedrooms}</strong></li>
              <li>Baths: <strong>{item.No_of_Bathroom}</strong></li>
              <li>Sqft: <strong>{Number(item.size).toLocaleString()}</strong></li>
            </ul>
          </div>

          <div className="content-bottom mb-10">
            <Link  className="whitefont fullwidth" to={`/property/${item.url}/${item.id}`}>
            <h6 className="price">
              AED {Number(item.price).toLocaleString()}
            </h6>
            </Link>
          </div>
          
          <div className="property-icns-w">
                                    <Link to="tel:+971501577822">
                                      {" "}
                                      <i className="icon">
                                        <img src="/images/img/phone.svg" />
                                      </i>
                                      Call
                                    </Link>
                                    <Link to="mailto:info@nvrealestate.ae">
                                      {" "}
                                      <i className="icon">
                                        <img src="/images/img/email.svg" />
                                      </i>
                                      Email
                                    </Link>
                                    <Link
                                    to={`https://web.whatsapp.com/send?phone=971544544287&text=Hi, I am interested in the listing, ${item.title}, from your website. I would like to get more information, please. Thank you.`}
                                    target="_blank"
                                    >
                                      <i className="icon">
                                        <img src="/images/img/whatsapp.svg" />
                                      </i>{" "}
                                      Whatsapp
                                    </Link>
                                  </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;
